export default {
      id: "wa-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "app/svg/sprite.svg#wa",
      toString: function () {
        return this.url;
      }
    }